import fetch from 'isomorphic-fetch';
import { EventTypes } from 'redux-segment';
import moment from 'moment';
import * as ActionType from './types/OnboardActionTypes';

function handleErrors(response) {
  if (!response.ok) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  return response;
}

export function resetStep() {
  return {
    type: ActionType.RESET_STEP
  };
}

export function incStep() {
  return (dispatch, getState) => {
    const nextStep = getState().Onboard.step + 1;
    dispatch({
      type: ActionType.INC_STEP,
      meta: {
        analytics: [
          {
            eventType: EventTypes.page,
            eventPayload: {
              properties: {
                path: `/wedding/onboard/step-${nextStep}`
              }
            },
          },
        ],
      }
    });
  };
}

export function decStep() {
  return (dispatch, getState) => {
    const nextStep = getState().Onboard.step - 1;
    dispatch({
      type: ActionType.DEC_STEP,
      meta: {
        analytics: [
          {
            eventType: EventTypes.page,
            eventPayload: {
              properties: {
                path: `/wedding/onboard/step-${nextStep}`
              }
            },
          },
        ],
      }
    });
  };
}

export function checkingSlug() {
  return {
    type: ActionType.CHECK_SLUG_AVAILABLE
  };
}

export function requestUpdateSlug() {
  return {
    type: ActionType.REQUEST_UPDATE_SLUG
  };
}

// sets which product the user is primarily using
// based on pkey or user selection
export function setPrimaryProduct(productKey) {
  return {
    type: ActionType.PRIMARY_PRODUCT_SELECTED,
    payload: productKey
  };
}

export function receiveSlugAvailability(response) {
  return {
    type: ActionType.SLUG_AVAILABILITY_RECEIVED,
    payload: response.data
  };
}

export function receiveSlugSuggestions(response) {
  return {
    type: ActionType.SLUG_SUGGESTIONS_RECEIVED,
    payload: response.data
  };
}

export function receiveUpdatedSlug(response) {
  return {
    type: ActionType.RECEIVE_UPDATED_SLUG,
    payload: response.data
  };
}

export function checkSlugAvailability(slug) {
  return (dispatch) => {
    dispatch(checkingSlug());
    return fetch(`/web-api/v1/wedding/slug/${slug}/available`,
      {
        credentials: 'same-origin',
      })
      .then(response => response.json())
      .then(json => dispatch(receiveSlugAvailability(json)))
      .then(action => action);
  };
}

export function getSlugSuggestions(suggestionData) {
  const { primaryFirstName, partnerFirstName, primaryLastName, partnerLastName, eventDate } = suggestionData;
  return (dispatch) => {
    dispatch(checkingSlug());
    const epoch = moment(eventDate).valueOf() || '';
    const slugData = {
      owner_first_name: primaryFirstName,
      owner_last_name: primaryLastName,
      partner_first_name: partnerFirstName,
      partner_last_name: partnerLastName,
      event_date: epoch
    };
    return fetch('/web-api/v1/wedding/slug/suggestions',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(slugData)
      })
      .then(response => response.json())
      .then(json => dispatch(receiveSlugSuggestions(json)));
  };
}

// TODO: maybe move slug actions into another file becuase not really related to onboarding anymore;
export function updateSlug(request) {
  return (dispatch) => {
    dispatch(requestUpdateSlug());
    return fetch('/web-api/v1/wedding/slug',
      {
        method: 'PUT',
        credentials: 'same-origin',
        body: JSON.stringify(request),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(handleErrors)
      .then(response => response.json())
      .then((json) => {
        dispatch(receiveUpdatedSlug(json));
        return json;
      });
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/OnboardActions.js
 **/